import { render, staticRenderFns } from "./LatestClients.vue?vue&type=template&id=249fb2be&scoped=true&"
import script from "./LatestClients.vue?vue&type=script&lang=js&"
export * from "./LatestClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249fb2be",
  null
  
)

export default component.exports